/* This file is generated by createIcons.js any changes will be lost. */
import createIcon from '../createIcon';
export const CloudsmithIconConfig = {
  name: 'CloudsmithIcon',
  height: 512,
  width: 332,
  svgPath: 'M332.5 419.9c0 46.4-37.6 84.1-84 84.1s-84-37.7-84-84.1 37.6-84 84-84 84 37.6 84 84zm-84-243.9c46.4 0 80-37.6 80-84s-33.6-84-80-84-88 37.6-88 84-29.6 76-76 76-84 41.6-84 88 37.6 80 84 80 84-33.6 84-80 33.6-80 80-80z',
  yOffset: '',
  xOffset: '',
  transform: ''
};
export default createIcon(CloudsmithIconConfig);
//# sourceMappingURL=cloudsmith-icon.js.map